document.addEventListener('DOMContentLoaded', function () {
  if (!document.getElementById('description-accordion-styles')) {
    const style = document.createElement('style');
    style.id = 'description-accordion-styles';
    style.textContent = `
      .product-description-accordion > summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        cursor: pointer;
        list-style: none;
      }

      .product-description-accordion > summary::-webkit-details-marker {
        display: none;
      }

      .product-description-accordion > summary::after {
        content: "+";
        flex-shrink: 0;
        font-size: 22px;
        font-weight: 400;
      }

      .product-description-accordion[open] > summary::after {
        content: "−";
      }
    `;
    document.head.appendChild(style);
  }

  document.querySelectorAll('.prose').forEach(function (prose) {
    prose.querySelectorAll('h3').forEach(function (heading) {
      if (heading.closest('details')) return;

      const details = document.createElement('details');
      details.classList.add('product-description-accordion');

      const summary = document.createElement('summary');
      
      summary.textContent = heading.textContent.trim();
details.appendChild(summary);

const title = summary.textContent
  .normalize('NFKC')
  .replace(/\s+/g, ' ')
  .trim();

const isAboutSection =
/^(?:(?:about|tietoa|tietoja|über|ueber|om|over|à propos|a propos)(?=\s|:|$)|ALPAKA-tuotteista$)/i.test(title);


if (isAboutSection) {
  details.setAttribute('data-brand-about', '');
  details.style.setProperty('display', 'none', 'important');
}


      let node = heading.nextSibling;

      while (node) {
        if (
          node.nodeType === 1 &&
          /^H[1-3]$/.test(node.tagName)
        ) {
          break;
        }

        const next = node.nextSibling;
        details.appendChild(node);
        node = next;
      }

      heading.replaceWith(details);
    });
  });
});

